module.exports = __webpack_public_path__ + "static/media/RJ.beeef8bf.png";